
export default {
    data: () => ({
        iframeInterval: null,
    }),
    methods: {
        reloadIfNoContent(iframeRef, iframeUrl) {
            this.iframeInterval = setInterval(() => {
                const document = iframeRef.contentDocument
                if (document && (document.readyState !== 'loading')) {
                    iframeRef.src = iframeUrl
                }
            }, 1000)
        },
        stopReloading() {
            clearInterval(this.iframeInterval)
        }
    }
}
